var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "29px",
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB90D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3730B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "4.74679129%",
    fx: "50%",
    fy: "4.74679129%",
    r: "72.2635651%",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF9CB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF04C",
    offset: "44.0876695%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB90D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "52.6088169%",
    cy: "28.2345201%",
    fx: "52.6088169%",
    fy: "28.2345201%",
    r: "89.6903887%",
    gradientTransform: "translate(0.526088,0.282345),scale(1.000000,0.625000),rotate(82.891853),translate(-0.526088,-0.282345)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#995723",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#633917",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-98.000000, -98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(97.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 14.5,
    cy: 14.5,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#radialGradient-2)",
    cx: 14.5,
    cy: 14.5,
    r: 13.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#703D0C",
    x: 9,
    y: 19,
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#613A19",
    cx: 1.75,
    cy: 2.5,
    rx: 1.75,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-3)",
    cx: 1.75,
    cy: 2.5,
    rx: 1.25,
    ry: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(19.000000, 11.500000) scale(-1, 1) translate(-19.000000, -11.500000) translate(17.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#613A19",
    cx: 1.75,
    cy: 2.5,
    rx: 1.75,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-3)",
    cx: 1.75,
    cy: 2.5,
    rx: 1.25,
    ry: 2
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/2.d425f6db7ae6fd68af006871768065ef.svg";